import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Title,
  Text,
  List,
  Image,
  ThemeIcon,
  useMantineTheme,
} from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

import ButtonBlock from '../ButtonBlock';
import * as classes from './Hero.module.css';


function Hero({
  heroSottotitolo,
  heroFeatures,
  heroButtons,
  heroTitolo,
  heroImage,
  stile
}) {
  const { colors } = useMantineTheme();

  return (
    <Container fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container>
        <div className={classes.inner}>
          <div className={heroImage?.url ? classes.content : classes.contentFullWidth}>
            <Title
              mb="lg"
              mt="sm"
              order={2}
              className={[classes.title, stile?.coloreDiSfondo && `title-${stile?.coloreDiSfondo}`].filter((f) => (f)).join(' ')}
              dangerouslySetInnerHTML={{ __html: heroTitolo.replace('<p>', '').replace('</p>', '') }}
            />
            <Text span className={classes.sottotitolo} dangerouslySetInnerHTML={{ __html: heroSottotitolo.replace('<p>', '').replace('</p>', '') }} />
            <List
              mt={30}
              spacing="sm"
              size="sm"
              icon={(
                <ThemeIcon size={26} radius="xl" color="brand">
                  <IconCheck style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ThemeIcon>
              )}
            >
              {heroFeatures.map(({ bloccoHeroTitolo, bloccoHeroFeature }, k) => (
                <List.Item key={`hero_list_li_${k + 1}`}>
                  <strong>{bloccoHeroTitolo}</strong> – <span>{bloccoHeroFeature}</span>
                </List.Item>
              ))}
            </List>

            <ButtonBlock buttons={heroButtons} />
          </div>
          {heroImage?.url && (
            <Image
              aria-hidden="true"
              className={classes.image}
              src={heroImage.url}
              alt={heroImage.alt}
              title={heroImage.title}
            />
          )}
        </div>
      </Container>
    </Container>
  );
}

Hero.propTypes = {
  heroSottotitolo: PropTypes.string,
  heroFeatures: PropTypes.arrayOf(
    PropTypes.shape({
      bloccoHeroTitolo: PropTypes.string.isRequired,
      bloccoHeroFeature: PropTypes.string.isRequired
    }).isRequired
  ),
  heroButtons: PropTypes.array,
  heroTitolo: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
  }),
};

export default Hero;
